import script from "./TrainerSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainerSessionDetailsPage.vue?vue&type=style&index=0&id=309a73b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309a73b6"]])

export default __exports__